
import { BlogDataModel } from '@shared/models/blog.model';

export const blogData: BlogDataModel[] = [
    {
        cImages: [
            { url: 'assets/images/traces/carmelDear.jpg', description: 'אייל הכרמל' },
            { url: 'assets/images/traces/rabbit.jpg', description: 'ארנבת' },
            { url: 'assets/images/traces/rabbit2.jpg', description: 'ארנבת מצויה' },
            { url: 'assets/images/traces/gamal.jpg', description: 'גמל' },
            { url: 'assets/images/traces/garbil.jpg', description: 'גרביל' },
            { url: 'assets/images/traces/girit.jpg', description: 'גירית' },
            { url: 'assets/images/traces/dorban.jpg', description: 'דורבן' },
            { url: 'assets/images/traces/zeav.jpg', description: 'זאב' },
            { url: 'assets/images/traces/holda.jpg', description: ' חולדה' },
            { url: 'assets/images/traces/keves.jpg', description: ' כבש' },
            { url: 'assets/images/traces/yael1.jpg', description: ' יעל' },
            { url: 'assets/images/traces/yael2.jpg', description: ' יעל' },
            { url: 'assets/images/traces/yarbou.jpg', description: ' ירבוע מצוי' },
            { url: 'assets/images/traces/cat2.jpg', description: '  חתול בית' },
            { url: 'assets/images/traces/cat1.jpg', description: 'כיסוי גללי חתול' },
            { url: 'assets/images/traces/merion2.jpg', description: 'מריון חולות' },
            { url: 'assets/images/traces/nimia1.jpg', description: ' נמייה' },
            { url: 'assets/images/traces/nimia2.jpg', description: ' נמייה' },
            { url: 'assets/images/traces/cow.jpg', description: 'פרה' },
            { url: 'assets/images/traces/zvi1.jpg', description: ' צבי' },
            { url: 'assets/images/traces/zvi5.jpg', description: 'מרבץ צבי' },
            { url: 'assets/images/traces/zvi6.jpg', description: ' צבי הנגב' },
            { url: 'assets/images/traces/kipod.jpg', description: 'קיפוד חולות' },
            { url: 'assets/images/traces/kipod1.jpg', description: 'קיפוד מצוי' },
            { url: 'assets/images/traces/zavoa.jpg', description: ' צבוע' },
            { url: 'assets/images/traces/boar11.jpg', description: ' חזיר בר' },
            { url: 'assets/images/traces/boar8.jpg', description: 'נבירות חזיר בר' },
            { url: 'assets/images/traces/boar9.jpg', description: 'שכיבה חזיר בר' },
            { url: 'assets/images/traces/boar7.jpg', description: 'לעוסית של חזיר בר' },

            { url: 'assets/images/traces/karakal.jpg', description: 'קרקל' },
            { url: 'assets/images/traces/ream.jpg', description: 'ראם' },
            { url: 'assets/images/traces/fox4.jpg', description: 'שועל מצוי' },
            { url: 'assets/images/traces/fox3.jpg', description: 'שיחור מזון של שועל' },
            { url: 'assets/images/traces/sela.jpg', description: ' שפן סלעים' },
            { url: 'assets/images/traces/tan1.jpg', description: 'תן בישיבה' },
            { url: 'assets/images/traces/tan2.jpg', description: 'תן זהוב' },

        ],
        category: 'mammals',
        name: 'יונקים',
        data: []
    },
    {
        cImages: [
            { url: 'assets/images/traces/nihoshit.jpg', description: 'נחושית החולות' },
            { url: 'assets/images/traces/yashmini.jpg', description: 'ישימונית' },
            { url: 'assets/images/traces/zikit.jpg', description: 'זיקית' },
            { url: 'assets/images/traces/hamot.jpg', description: 'חומט גמד' },
            { url: 'assets/images/traces/hardon.jpg', description: 'חרדון' },
            { url: 'assets/images/traces/koha.jpg', description: 'כוח אפור' },
            { url: 'assets/images/traces/sandSneck.jpg', description: 'נחש חולות' },
            { url: 'assets/images/traces/zav.jpg', description: 'צב יבשה מצוי' },
            { url: 'assets/images/traces/zefa.jpg', description: 'צפע ארץ ישראלי' },
            { url: 'assets/images/traces/shinanit.jpg', description: 'שנונית חולות' },

        ],

        category: 'reptiles',
        name: 'זוחלים',
        data: []
    },
    {
        cImages: [
            { url: 'assets/images/traces/ouah.jpg', description: 'אוח עיטי' },
            { url: 'assets/images/traces/anafit.jpg', description: 'אנפית בקר' },
            { url: 'assets/images/traces/anafa.jpg', description: 'אנפה אפורה' },
            { url: 'assets/images/traces/baz.jpg', description: 'בז מצוי' },
            { url: 'assets/images/traces/dohifat.jpg', description: 'דוכיפת ' },
            { url: 'assets/images/traces/dror.jpg', description: 'דרור' },
            { url: 'assets/images/traces/hogla.jpg', description: 'חוגלה ' },
            { url: 'assets/images/traces/hogla1.jpg', description: 'אמבטיית חול חגלה' },
            { url: 'assets/images/traces/hobra.jpg', description: 'חוברה' },
            { url: 'assets/images/traces/hasida.jpg', description: 'חסידה' },
            { url: 'assets/images/traces/yeorit.jpg', description: 'יאורית מצרית' },
            { url: 'assets/images/traces/yona.jpg', description: 'יונת בית' },
            { url: 'assets/images/traces/yergezi.jpg', description: 'ירגזי' },
            { url: 'assets/images/traces/kos.jpg', description: 'כוס חורבות ' },
            { url: 'assets/images/traces/kavran.jpg', description: 'כרוון' },
            { url: 'assets/images/traces/sofit.jpg', description: 'סופית' },
            { url: 'assets/images/traces/siksak.jpg', description: 'סיקסק' },
            { url: 'assets/images/traces/siksak1.jpg', description: 'סיקסק' },
            { url: 'assets/images/traces/snonitShit2.jpg', description: 'סנונית מערות מלקטת בוץ' },
            { url: 'assets/images/traces/mina.jpg', description: 'מינה' },
            { url: 'assets/images/traces/nahliali.jpg', description: 'נחליאלי ' },
            { url: 'assets/images/traces/zozelet.jpg', description: 'צוצלת' },
            { url: 'assets/images/traces/kokia.jpg', description: 'קוקיה מצויצת' },
            { url: 'assets/images/traces/orev.jpg', description: 'עורב' },
            { url: 'assets/images/traces/orvani.jpg', description: 'עורבני' },
            { url: 'assets/images/traces/efroni.jpg', description: 'עפרוני מצוייץ' },
            { url: 'assets/images/traces/sharor.jpg', description: 'שחרור' },
            { url: 'assets/images/traces/torit.jpg', description: 'תורית זנבנית ' },
            { url: 'assets/images/traces/tahmas1.jpg', description: 'תחמס ' },
        ],
        category: 'birds',
        name: 'ציפורים',
        data: []
    },
    {
        cImages: [
            { url: 'assets/images/traces/arodit.jpg', description: 'ארודית החולות' },
            { url: 'assets/images/traces/arthropods1.jpg', description: 'עכביש' },
            { url: 'assets/images/traces/alex.jpg', description: 'זחל פרפראי' },
            { url: 'assets/images/traces/tiko.jpg', description: 'תיקנחול' },
            { url: 'assets/images/traces/ratza.jpg', description: 'רצה מצויירת' },
            { url: 'assets/images/traces/shlomo.jpg', description: 'גמל שלמה' },
            { url: 'assets/images/traces/shilsholShit.jpg', description: 'גללי שלשול' },
            { url: 'assets/images/traces/zivlit.jpg', description: 'דרן זבלית' },
            { url: 'assets/images/traces/darhol.jpg', description: 'דרחול השיח' },
            { url: 'assets/images/traces/zivlit2.jpg', description: 'זבלית נקודה ' },
            { url: 'assets/images/traces/zivlit3.jpg', description: 'זבלית מגלגלת כדור זבל' },
            { url: 'assets/images/traces/ari.jpg', description: 'זחל ארינמל' },
            { url: 'assets/images/traces/tvai.jpg', description: 'זחל טוואי לסיוקמפה' },
            { url: 'assets/images/traces/tail.jpg', description: 'זחל תיל' },
            { url: 'assets/images/traces/hagav.jpg', description: 'חגב עם קפיצה בסוף' },
            { url: 'assets/images/traces/hagav1.jpg', description: 'חגב' },
            { url: 'assets/images/traces/kadrorit.jpg', description: 'כדרורית' },
            { url: 'assets/images/traces/scorpion.jpg', description: 'עקרב' },
            { url: 'assets/images/traces/ravgaf.jpg', description: 'רבגף חום' },
            { url: 'assets/images/traces/kartzia.jpg', description: 'קרצייה' },
            { url: 'assets/images/traces/dvora.jpg', description: 'דבורת דבש' },
            { url: 'assets/images/traces/blfes.jpg', description: 'חיפושית בלפס' },
            { url: 'assets/images/traces/ant.jpg', description: 'נמלה מעוף כלולות' },
            { url: 'assets/images/traces/zaevan.jpg', description: 'עכביש זאבן' },
            { url: 'assets/images/traces/spiderHafran.jpg', description: 'עכשוב חפרן' },
            { url: 'assets/images/traces/ziraa.jpg', description: 'צרעה מלקטת בוץ' },
            { url: 'assets/images/traces/builderBee.jpg', description: 'קן של דבורה בנאית' },
            { url: 'assets/images/traces/nadal.jpg', description: 'רב נדל ארסי' },
            { url: 'assets/images/traces/shinanit2.jpg', description: 'שיננית החוף' },
            { url: 'assets/images/traces/shablool1.jpg', description: 'שבלול מתחפר' },
            { url: 'assets/images/traces/shablool2.jpg', description: 'שבלול השדה' },
            { url: 'assets/images/traces/refoanit.jpg', description: 'רפואנית' },
            { url: 'assets/images/traces/kitfit.jpg', description: 'קטיפית ארבע כתם' },
        ],
        category: 'arthropods',
        name: 'פרוקי רגליים',
        data: []
    },
    {
        cImages: [
            { url: 'assets/images/traces/rabit.jpg', description: 'גללי ארנבת' },
            { url: 'assets/images/traces/giritShit.jpg', description: 'גללי גירית מצויה' },
            { url: 'assets/images/traces/camleShit.jpg', description: 'גללי גמל' },
            { url: 'assets/images/traces/wolfShit.jpg', description: 'גללי זאב' },
            { url: 'assets/images/traces/mouseShit.jpg', description: 'גללי חולדה' },
            { url: 'assets/images/traces/yaelShit.jpg', description: 'גללי יעל' },
            { url: 'assets/images/traces/cohaShit.jpg', description: 'גללי כוח אפור' },
            { url: 'assets/images/traces/boarShit.jpg', description: 'גללי חזיר בר' },
            { url: 'assets/images/traces/snonitShit.jpg', description: 'גללי סנונית' },
            { url: 'assets/images/traces/cowShit.jpg', description: 'גללי פרה' },
            { url: 'assets/images/traces/leamShit.jpg', description: 'גללי כבש' },
            { url: 'assets/images/traces/peraShit.jpg', description: 'פרא' },
            { url: 'assets/images/traces/dorbanShit.jpg', description: 'גללי דורבן' },
            { url: 'assets/images/traces/catShit.jpg', description: 'גללי חתול' },
            { url: 'assets/images/traces/hoglaShit.jpg', description: 'גללי חוגלה' },
            { url: 'assets/images/traces/drorShit.jpg', description: 'גללי דרור' },
            { url: 'assets/images/traces/tanShit.jpg', description: 'גללי תן זהוב' },
            { url: 'assets/images/traces/KipdShit.jpg', description: 'גללי  קיפוד' },
            { url: 'assets/images/traces/karpada.jpg', description: 'גללי קרפדה' },
            { url: 'assets/images/traces/hyenaShit.jpg', description: 'גללי צבוע' },
            { url: 'assets/images/traces/zviShit.jpg', description: 'גללי צבי ארץ ישראלי' },
            { url: 'assets/images/traces/tahvan.jpg', description: 'טחבן המדבר' },
        ],
        category: 'dumplings',
        name: 'גללים',
        data: []
    },
    {
        cImages: [
            { url: 'assets/images/traces/carpada1.jpg', description: 'קרפדה ניתורים' },
            { url: 'assets/images/traces/carpada2.jpg', description: 'קרפדה' },
            { url: 'assets/images/traces/carpada3.jpg', description: 'קרפדה' },
        ],
        category: 'amphibians',
        name: 'דו-חיים',
        data: []
    },
    {
        cImages: [],
        category: 'thought',
        name: 'מאמרים',
        data: [
            {
                Id: 1,
                images: [
                    { url: 'assets/images/traces/deer.jpg', description: ' צבי' }],
                date: 'אוקטובר 2019',
                type: 'מדבר יהודה',
                title: 'סוגי גששות מעקב',
                content: ` ניתן לדבר על שלושה סוגי גששות מעקב כפי שמתוארים בספר "גששות פרקטית" (ליבנברג, לאו ואלברוך) ובהתאם ללימודי באפריקה.\n
                גששות  שיטתית (סיסטמטית)
                פירושו של דבר לגשש עקבה אחר עקבה, סימן אחר סימן במטרה לקלוט ולזהות את כל העקבות והסימנים
                בנתיב העקבות. בסוג זה של גששות לא נתקדם מעבר לעדויות אותן אנו רואים.
                יתרון: סיכוי טוב יותר שלא נאבד את העקבות ואת "שביל" הגישוש. בשטחים בהן העקבות ברורות מאוד
                ניתן להתקדם במהירות.
                חיסרון: זהו תהליך איטי יחסית ,בעיקר באזורים בהם קשה לראות את העקבות הסיכוי לסגור את הפער
                אל החיה ולהגיע אליה נמוך.

                גששות השערתית ( ספקולטיבית)
                בגששות זו אנחנו מנסים "להיכנס לראש" של החיה ולשער באיזו דרך/נתיב היא עברה ואז הולכים בדרך זו
                כאשר אנחנו מוודאים מדי פעם עם העקבות שעל הקרקע שאנחנו בדרך הנכונה. לעיתים נתקדם על פי
                השערתנו ללא עדויות פיזיות אותן אנו רואים בשטח. ננסה לשער היכן ימצאו העקבות ולשם נלך.
                כמובן שנצטרך לאמת את השערתנו עם עדויות בשטח .
                לדוגמא: אנחנו הולכים בשביל נוח עליו אנו רואים את עקבות החיה ובמקום להמשיך לחפש עקבה אחר
                עקבה אנחנו מרימים את ראשנו ומסתכלים קדימה, אנחנו משערים שהחיה ככל הנראה המשיכה ללכת על
                אותו השביל ולכן מחפשים עקבות וסימנים במרחק ( לצורך הדוגמא, 10 מטרים קדימה) במידה ומצאנו אזי
                אנחנו ניגשים ישר לסימן שראינו (מבלי להתעכב ולנסות למצוא כל עקבה בדרך) ומוודאים תוך כדי תנועה שזו
                באמת העקבה של החיה אחריה אנו עוקבים ובו זמנית ממשיכים לחפש עקבות וסימנים במרחק.
                וכך מתחיל להיווצר מומנטום וקצב לגישוש ולא מצב של עצירה/המשך עצירה/המשך
                דוגמא נוספת: אנחנו עוקבים אחר החיה בדרך מסוימת ואנו רואים שבהמשך הדרך מתפצלת לשלוש
                דרכים/נתיבים שונים, ננסה לשער באיזו דרך בחרה החיה ושם נחפש עדויות לכך שהיא אכן עברה בדרך בה
                שיערנו שהיא תעבור. במידה וטעינו נבחר בהשערה אלטרנטיבית שנראית לנו הכי הגיונית עבור החיה
                אחריה אנו עוקבים ונחפש שם עדויות תומכות וכן הלאה. לא תמיד נראה עקבות אם בגלל תנאי השטח או
                סיבות אחרות ולכן לעיתים נדרש לשער באיזה נתיב התקדמה החיה ורק בהמשך למצוא עדויות תומכות.
                יתרון: לא נתעכב על למצוא כל עקבה ועקבה. לעיתים יש עקבות שקשה עד בלתי אפשרי למצוא אותן ולכן
                לחפש אותן יכול לגרום לבזבוז זמן משמעותי בהנחה שנוכל לאתר אותן בקלות בהמשך.
                כך ניתן לצבור יותר מומנטום ולסגור את הפער אל החיה מהר יותר
                חיסרון: נתקדם על פי השערתנו מעבר לעדויות הפיזיות בשטח ולכן קיים סיכוי גבוה יותר לאיבוד "שביל"
                העקבות (נתיב התקדמות החיה)\n
                גששות אינטואיטיבית
                במובן מסוים ייתכן שגששות זו הינה הרחבה של גששות ספקולטיבית.
                להבנתי גששות זו מבוססת על שני גורמים מרכזיים:
                הכרות טובה עם האזור הספציפי בו אנו מגששים והכרות טובה עם החיה אחריה אנחנו עוקבים.
                גופנו ממקבל אינספור גירויים שונים מן הסביבה ולעיתים הם לא נקלטים במודע אך מורגשים בגוף
                (אולי כ"תחושת בטן"),על הגשש להיות ערני גם לכך ולאמת את הדברים עם העובדות בשטח.
                דוגמא: אני מתחיל לגשש אחר חזירי בר, אני מכיר טוב את האזור בו אני מגשש אחריהם ומכיר מקומות
                ספציפיים בהם הם אוהבים לשהות בשעות מסוימות .
                 כיוון ההתקדמות הכללי על פי העקבות והסימנים נראה כמוביל לאחד האזורים אותם אני מכיר ובו אני יודע
                שהם אוהבים לשהות , אזי אני יכול לבחור ללכת ישר לשם ולמצוא שם את עקבותיהם או אפילו אותם.
                יתרון: חוסך המון זמן
                חיסרון: במידה וטעינו והחיה לא תמצא באזור אז בזבזנו הרבה מאוד זמן וסיכויינו להגיע לחיה פוחתים מאוד. \n

                גשש טוב יודע מתי להשתמש באיזה סוג גששות, זאת בהתאם ליכולתו ולתנאי השטח
                `,
                btn: 'קיראו עוד',
                auther: 'עודד דוידוביץ',
            },
            {
                Id: 2,
                images: [{ url: 'assets/images/traces/edu1.jpg', description: 'גששות ככלי חינוכי' },
                { url: 'assets/images/traces/edu2.jpg', description: 'גששות ככלי חינוכי' }],
                date: 'אוקטובר 2019',
                type: 'פלמחים',
                title: ' גששות ככלי חינוכי',
                content: `
                כאשר אני מלמד גששות המטרה הראשונה שלי הינה לעודד אהבה וחיבור לטבע. אני מאמין
שבכולנו קיים החיבור לטבע ואצל ילדים ניתן לראות זאת בברור, חוקרים בסקרנות קני נמלים,
עקבות, מטפסים על עצים, מתלכלכים בבוץ וחווים את הטבע עם כל הגוף והחושים.
עם השנים כמבוגרים החיים בעולם מערבי מתועש רובנו התרחקנו מהטבע ומהחיבור הטבעי והפשוט
הזה. חיבור אשר חיוני גם לבריאות הנפש .
בספרו "הילד האחרון בטבע" טבע ריצ'רד לאוב מושג בשם "הפרעת חוסר בטבע". אין מדובר
באבחנה רפואית אלא בתיאור התופעה של ריחוק האדם מן הטבע על ההשלכות והמחירים שנובעים
כתוצאה מזה.
כך ייתכן שאנשים שמרוחקים מן הטבע מועדים יותר לחוות תופעות של הפרעות קשב וריכוז,
השמנה, ירידה באמפטיה ובכישורים החברתיים, חוסר כבוד לטבע מסביבם ועוד...
גם ללא מחקרים מלומדים אפשר להכיר בתופעה הזו שבה (בשונה מדורות קודמים) בני האדם
שוהים פחות בטבע ויותר במרחב העירוני, במחשבים, סמרטפונים וכו'..ובבעיות שונות שנובעות מכך.
לעצם השהייה בטבע יש חשיבות בפני עצמה.

הגששות תורמת להבנת מרקם החיים בסביבה וליצירת אינטימיות עם הטבע.
עצם ההבנה שבעלי חיים שונים מסתובבים היכן שאנו נמצאים עכשיו גם אם איננו מבחינים בהם
הינה גורם חשוב המעורר אותנו לכבד את הטבע ולשמור עליו. הבנה זאת מתרחשת בין השאר עם
זיהוי העקבות והסימנים של בעלי החיים השונים באזור. זיהוי עקבות יכול לכלול בתוכו מספר דברים
כגון: יכולת ניתוח, חשיבה ביקורתית , דמיון והסקת מסקנות .
אך גששות זה לא רק לזהות מי עשה את העקבה, זה גם מודעות וערנות לפרטים קטנים שרובנו לא
שמים לב אליהם ביום יום אבל לאחר שנלמד לזהותם "פתאום" נתחיל לראותם יותר ויותר. לצד זה
ישנה גם מודעות ל"תמונה הגדולה" ולהתבוננות על הטבע (והחיים) כמכלול אחד. התבוננות שכזו
תורמת להבנת חיבורים שונים בין תוואי השטח והנוף ובין החיה ומקדמת את ההבנה הפשוטה אך
הנשכחת לעיתים שכל הדברים קשורים ומשפיעים אחד על השני.
לדוגמא: בחירת נתיב ההתקדמות של בעל החיים אינה שרירותית בדרך כלל.
בעל החיים יבחר בדרך הנוחה ביותר עבורו, דרך שאולי מובילה למקורות מזון, דרך שמובילה לאזורי
מחסה ומסתור וכו'...
על כן במקביל לזיהוי עקבות נתרגל גם הבנה של התנהגות החיה על פי העקבות והסימנים.
מה עשתה החיה? מדוע עברה היכן שעברה? מה היה אופן תנועתה? ניתוח גללי החיה על מנת
להבין מה אכלה ועוד..
תובנות אלו מחברות אותנו לכלל הסביבה ובכך אנו מרחיבים את תחומי הידע שלנו מעבר לזיהוי
מצומצם של איזו עקבה שייכת לאיזו חיה. כך לדוגמא נשאף להכיר סוגי צמחים שונים אשר יכולים
להוות מקור מזון לבעל החיים אחריו אנו עוקבים (במידה והוא ניזון מצמחים), נכיר ונלמד סוגי
קרקע שונים אשר משפיעים על מראה העקבה, נבין כיצד מזג האוויר יכול להשפיע על אופן
פעילותם של החיים באזור ועל העקבות והסימנים שבעלי החיים משאירים אחריהם.
תרגול זה מאפשר לנו "להיכנס לראש" של החיה על מנת להבין אותה ואת התנהגויותיה כפי שפרשנו
על פי העדויות בשטח ובעזרת הדמיון.
עבורי, תרגול זה וגששות מעקב אחר בעל החיים תורמים לפיתוח אמפטיה עבור בעל החיים אחריו
אנו עוקבים.
זה לא משהו זר ולא מוכר, זו לא "סתם" חיה זה ייצור חי עם דרכי התנהגות, רצונות ואופי משלו.

אחד הכוחות החזקים המניעים אותי בגששות הוא הסקרנות, לשאול שאלות ולנסות למצוא תשובות.
במובן הזה גשש הוא באמת קצת כמו בלש. שאילת שאלות יחד עם החניכים מעודדת סקרנות, דמיון
וחשיבה עצמאית. זאת בשונה מאמירת התשובה באופן ישיר ומיידי.
לא תמיד נמצא תשובות לחידות השונות אך חשוב להמשיך לשאול את השאלות ולפעמים חידות
מסוימות ימצאו מענה לאחר תקופה כזו או אחרת (לעיתים שנים). ולכן גם סבלנות זו מעלה חשובה
שניתן לפתח בעזרת הגששות.
בעת הדרכת גששות אני שואף לאפשר חוויה לימודית רב ממדית הפונה גם לצד הלוגי שלנו
(אם תרצו "מוח שמאל") וגם לחוויה בגוף ולדמיון ("מוח ימין"). על כן במידה והדבר מתאפשר
ובטיחותי, נשתדל לחקור עם כל החושים. פיתוח כל החושים מספק חוויה מלאה יותר ומודעות רחבה
לסובב אותנו.
ובנימה יותר אישית, עולם הגששות מהווה עבורי חיבור מופלא לטבע על ידי עצם השהייה בטבע,
חקירתו, הכרות אינטימית עם בעלי החיים, הצמחים והסובב אותנו.
החיבור הזה עוזר לי ומשמח אותי ובכך אני חש יותר קרוב לטבע ופחות לעולם העירוני והתעשייתי
שיכול להיות מנוכר לעיתים, שהרי גם אני מתבונן לא מעט ואפילו "מכור" לפעמים לצגי המחשב
והפלאפון, אז אני בהחלט מקווה ומאמין שאני מאזן זאת בעזרת הגששות

                `,
                btn: 'קיראו עוד',
                auther: 'עודד דוידוביץ',
            },
            {
                Id: 3,
                images: [{ url: 'assets/images/traces/trace359.jpg', description: '' }],
                date: 'ינואר 2019',
                type: 'פלמחים',
                title: 'אתיקה ובטיחות בעת גששות ',
                content: `
                אנחנו אורחים בביתו של בעל החיים ולכן נשאף למינימום הפרעה לסביבה, לבעלי החיים ולצומח.
במידה ופגשנו בעל חיים והפחדנו אותו אזי לא נמשיך לעקוב אחריו.
לא נעקוב אחרי פרט בוגר עם צאצאים קטנים.
לא נגשש גששות מעקב בשמורות טבע .
לא נתקרב למחילות או קנים.
ניתן לבצע גששות לאחור (הפוך לכיוון תנועת החיה), כלומר, לנסות לגשש ולהבין מהיכן החיה
 הגיעה.
נשאף לשתף ידע מהימן בצורה שקופה ופתוחה.
בטיחות----------
ניסיון משמעותי בהתנהלות נכונה ומתאימה בשטח/טבע הינו חשוב כאשר יוצאים לגשש.
 כולל ידע בעזרה ראשונה בסיסית ויכולת ניווט והתמצאות במרחב.
 מטבע הדברים מרבית הגששות שלנו תתקיים בשטחי טבע שונים, לצד ההנאה הגדולה בטבע,
 חשוב לזכור שהטבע יכול לזמן אתגרים שונים כגון: תוואי שטח קשה, מזג אוויר ,צמחייה רעילה
 ו/או קוצנית, בעלי חיים שונים ועוד...
להיות ערניים לחוקים וההנחיות המתאימות לתא השטח הספציפי , למזג האוויר ובאופן כללי
 לשהות בשטח.
 מודעות לסיכונים אפשריים ממפגשים עם בעלי חיים שונים ולדעת כיצד להתמודד עמם.
לא נכנס למחילות או מעברים צרים (כגון: "מנהרות " בתוך סבך צמחי ) אשר לא מאפשרות נתיב
 בריחה לחיה ולגשש עצמו.
מודעות לקרציות, דבורים/צרעות, עקרבים, נחשים.
לדווח למשפחה/חברים היכן אתם מגששים, אם אפשר גששו ביחד עם עוד מישהו, לעיתים יש לזה
 ערך מוסף גם מעבר לצד הבטיחותי.
להיות מודעים לסביבה ולזמן. לא פעם ארע לי ששקעתי עמוק בגישוש ולפני ששמתי לב השמש כבר
 שקעה והייתי רחוק מהרכב שלי ונאלצתי ללכת מרחק רב חזרה כאשר כבר התחיל להחשיך.
הצטיידו בכמות מספיקה של מים ומזון ובלבוש מתאים.

*מומלץ להתחיל לגשש יחד עם גשש מנוסה*

                `,
                btn: 'קיראו עוד',
                auther: 'עודד דוידוביץ',
            },
            {
                Id: 4,
                images: [
                    {
                        url: 'assets/images/traces/giul2.jpg',
                        description: `
                    ממדידות שונות בחודשי אביב/קיץ במהלך היום ניכר שלזחל הארינמל לוקח כחצי שעה עד שעה בערך להשלים את גומת הצייד שלו לאחר שכוסתה בחול עם דרכו עליה
                    `
                    },
                    {
                        url: 'assets/images/traces/giul1.jpg',
                        description: ' עקבות צבי החוצות על גבי עקבות חזיר בר שנע משמאל לימין'
                    },
                    {
                        url: 'assets/images/traces/giul3.jpg',
                        description: 'בתמונה עקבות צבי א"י אשר זיהיתי בשעות אחר הצהריים. בחלקה העליון של העקבה הימנית ניתן לראות עקבת ציפור מסוג כרוון שדרכה על עקבת הצבי'
                    },
                    {
                        url: 'assets/images/traces/giul4.jpg',
                        description: 'עקבת צבי ארץ ישראלי עם קורי עכביש עליה. ישנם עכבישים אשר יכולים לטוות רשת קורי עכביש בזמן של 30 -60 דקות. כיוון תנועה מימין לשמאל.'
                    },
                    {
                        url: 'assets/images/traces/giul5.jpg',
                        description: 'עקבת חזיר בר בחול עמוק שהתרחשה לאחר ירידה של טל על החול'
                    },
                ],
                date: 'אוקטובר 2019',
                type: 'פלמחים',
                title: 'קביעת גיל העקבה',
                content: `
"אחד הדברים היותר קשים בניתוח עקבות הינו קביעת גיל העקבה.
 רק גששים מנוסים מאוד יכולים לקבוע גיל של עקבות ברמת דיוק סבירה, כאשר רמת דיוק מוחלטת בדרך כלל לא אפשרית...
 עקב מורכבות המשתנים המעורבים הערכות הגיל הן בדרך כלל במקרה הטוב אינטואיטיביות"
 (Louis Liebenberg)

במובן הבסיסי והחשוב ביותר צריך הגשש להחליט מבחינה מעשית האם כדאי לגשש ולעקוב
אחר החיה או לא. כך לדוגמא אם העקבה נעשתה לפני מספר ימים אזי הסיכוי שנגיע לבעל
החיים הינו נמוך יותר בד"כ. יחד עם זאת לא תמיד יהיה לנו קל לקבוע את גיל העקבות.

כל עקבה שנוצרת נדונה להתכלות בסופו של דבר עד שהקרקע חוזרת למצבה הראשוני והלא מופרע.
(למעט במקרים מסוימים כגון: עקבות על מצע רך שמתקשה כגון מלט וכו'.)
תהליך ההתכלות של העקבה נוצר בין השאר עקב גורמי טבע שונים כגון:
שמש/חום: מייבשת את העקבה ואת הלחות שנותרה בה (לחות עקב ההעמקה לקרקע) ובכך תורמת
 לפיזור גרגרי החול בעקבה.
רוח: מזיזה את גרגרי החול ומעיפה חומרים שונים על העקבה ולתוכה (עלים, פסולת ועוד...).
מייבשת את הלחות שבעקבה (אם יש).
לחות/יובש: ככל שיבש יותר כך הלחות שבעקבה תתייבש מהר יותר והעקבה תראה ישנה יותר.
בתנאי לחות העקבה יכולה להחזיק יותר זמן מבלי להתיישן "כביכול"
גשם: יכול לעוות את העקבה ולשטח אותה, כמו כן כל העקבות שנעשו לפני הגשם יראו יותר דומות
אחת לשנייה מבחינת הגיל לאחר שהגשם ירד עליהן.
כוח המשיכה: מושך את גרגרי החול מטה.
מיקום העקבה: ברמת המאקרו, סוג הקרקע וטוואי השטח כמשפיעים על מראה העקבה ואופן
התיישנותה.
ברמת המיקרו, האם העקבה נעשתה במדרון? האם העקבה ממוקמת מתחת לעץ אשר נותן צל
על העקבה? האם העקבה ממוקמת באזור עם הרבה צמחייה מסביבה?
זמן: בד"כ ככל שעובר יותר זמן כך הגורמים שפורטו למעלה יכולים להשפיע יותר על העקבה.

על פי רוב, ככל שהעקבה טרייה יותר כך גדל הסיכוי שלנו להגיע אל החיה וזאת ממספר סיבות:
א. גדל הסיכוי שנראה עקבות/סימנים ברורים של החיה אחריה אנו עוקבים מכיוון שהעקבות פחות
הופרעו על ידי הגורמים שפורטו מעלה
ב. פחות הפרעות של בעלי חיים/בני אדם/רכבים שעלו על העקבות ומחקו אותן
ג. ככל שהעקבה טרייה יותר כך יהיה לנו יותר קל לזהותה ולהבדילה מעקבות אחרות של בעלי חיים
דומים באזור, שאולי ניתקל בהן על ציר העקבות במידה ועקבותיהם ישנות יותר
ד. בד"כ ,באופן הגיוני, ככל שעבר פחות זמן מרגע שהונחו העקבות כך החיה יותר קרובה אל הגשש.
אך יש לזכור שלא תמיד יש הלימה בין גיל העקבה למרחק החיה מאיתנו  גששות  מרחק החיה יכול
להיות מושפע מגורמים נוספים כגון: מהירות החיה, מה היא עשתה בדרך? האם אכלה?
האם עצרה למנוחה?.


מדדים לתיארוך עקבות
ישנם מספר מדדים העוזרים לנו לתארך את גיל העקבה ויש לשקלל את כולם יחד בתהליך הלמידה
כאשר צריך לזכור שבתנאים שונים חלק מהמדדים יראו אחרת או ייתנו לנו תיארוך אחר על כן
בסעיפים הבאים יוצגו מספר עקרונות להסתכלות אותם כדאי לבחון כאשר אתם מתרגלים את
הנושא.
1.צורה: האם שולי העקבה נראים חדים וברורים או מעוגלים ומטושטשים?
2.מרקם:האם פנים העקבה נראה ו/או מרגיש מהודק? מפורר? קשה יחסית? סדוק? מטושטש?
3.צבע: נשווה את צבע העקבה ביחס לסביבה הקרובה (הלא מופרעת), האם כהה יותר ?
בהיר יותר? אותו הדבר? האם ישנם סימני לחות/רטיבות?
4.חומרים שונים שהצטברו על העקבה: האם יש הרבה חומר צמחי (עלים, ענפים...)בתוך העקבה?
Superimposition5.עקבות בעלי חיים אחרים על גבי העקבה שלנו ועיקרון ה-סופראימפוזישן -
 (עקבה על גבי עקבה) עקרון פשוט זה קובע באופן הגיוני שכאשר עקבה אחת עולה על גבי עקבה
 אחרת אזי העקבה העליונה היא העקבה החדשה יותר.
 על כן אם נדע את שעות הפעילות של בעלי החיים באזור ונראה את עקבותיהן על גבי עקבות החיה
 אחריה אנו עוקבים ו/או את עקבות החיה אחריה אנו עוקבים על גבי עקבות אחרות נוכל לשער
 בטווח מסוים את גיל העקבה .


דוגמאות:
א. איתרתי בשעות בוקר מאוחרות מרבץ של צבי, לא היו עליו שום עקבות מלבד עקבות חגב
(פעיל יום בד"כ) אזי ההנחה שלי היא שהצבי קם מהמרבץ מעט לפני הזריחה או לאחר הזריחה
מכיוון שלא היו עקבות של בע"ח פעילי לילה על גבי סימני הרביצה, באזור שבו סביר היה שיהיו.

ב. אני רואה בשעת בוקר מאוחרת עקבות צבי ישראלי, לרוב פעיל יום, העקבות נראות לי די טריות
אך אני לא בטוח האם הן נעשו בבוקר או בערב שלפני. בהמשך הנתיב אני מזהה עקבות חזיר בר
שחוצות את נתיב עקבות הצבי , עקבות חזיר הבר נראות טריות גם כן אך ניכר שעקבות הצבי עלו על
 גבי עקבות חזיר הבר, כלומר הן חדשות יותר מעקבות החזיר.
 חזיר הבר הינו פעיל לילה על פי רוב על כן אני מניח שעקבות הצבי נעשו בבוקר היום בו גיששתי.

ג. חלזונות פעילים בד"כ בשעות הלילה ושעות הבוקר המוקדמות (אלא אם כן יורד גשם במהלך
היום).לכן אם אזהה בשעה 14:00 בצהריים עקבות ריר של חילזון על גבי  בעל  החיים אחריו
אני עוקב אזי אניח שבמינימום בעל החיים עבר כאן בשעות הבוקר המוקדמות או לפני כן.

ד. בעת מזג אוויר אביבי/חם הארינמל יכול לחפור את גומת הצייד שלו בכ-30 עד 60 ד' בערך.
על כן אם נראה עקבה שבתוכה גומת ארינמל שעדיין חופר את הגומה אזי נוכל לשער ש החיה
שדרכה על הגומה נעשתה בטווח של השעה האחרונה.

*בנסיבות מסוימות ואזורים מסוימים בעלי החיים יכולים להפתיע אותנו ולא להתנהג על
 פי זמני הפעילות המקובלים בספרים. הערה זו חשובה לעולם הגששות בכלל מכיוון שעולם זה
 משקף היטב את הדינמיות והשינויים בשטח ואצל בעלי החיים.

6. מזג האוויר: מודעות למזג האוויר. מתי ירד הגשם האחרון? האם ירד טל בלילה? מהן הרוחות
השולטות באזור? כיווני הרוח? עוצמת הרוח? טמפרטורה?

דוגמא לתיארוך בעזרת מזג אוויר : היום התחיל לרדת טפטוף גשם בשעה 9 בבוקר. הטפטוף
הפסיק בשעה 11:00 . הגעת למקום בשעה 16:00 והתחלת לעקוב אחר סוס שעבר באזור.
על גבי העקבות ראית את סימני העקבות של טיפות הגשם ולכן יכולת להגיד שהעקבות נעשו לפני
השעה 9:00 בבוקר או במהלך הטפטוף (9 עד 11) בסביבות השעה 17:00 המשכת על אותו ציר
עקבות אך כבר לא ראית סימני טיפות על העקבות. על כן ניתן להגיד שעקבות אלו נעשו משעה
11:00 ואילך, כלומר הסוס עבר כאן בטווח גג של שש השעות האחרונות.

7.סוג הקרקע ,תוואי השטח והנוף הסובב אותנו: לנתונים אלה יש השפעות שונות על מראה העקבה.
כך לדוגמא באזור של דיונות חול בשעה שמנשבת רוח חזקה אזי עקבות באזורים חשופים לרוח
ימחו מהר יחסית אך במידה והחיה נכנסה לאזור עם צמחייה אזי העקבות שעל החול ישתמרו טוב
יותר מכיוון שהצמחייה מגנה עליהן מפני הרוח ומפני שהשורשים של הצמחים מחזיקים את הקרקע
טוב יותר . מצד שני פעמים רבות באזורים עם הרבה צמחייה תתקיים פעילות יותר אינטנסיבית של
חרקים ויונקים קטנים כגון: מכרסמים שונים. פעילות זו יכולה לטשטש את חלק מהעקבות אותן אנו
מחפשים.
כך יכול להיווצר מצב שעל אותו ציר עקבות נראה עקבות בני אותו הגיל אך חלקן יהיו מטושטשות
מאוד (ולכן יראו ישנות יותר כביכול) ומספר מטרים לידן עקבות של אותה החיה הספציפית אחריה
אנו עוקבים יראו ברורות יחסית וכביכול יותר טריות.
על מנת להוסיף לאתגר חשוב לציין שכל שבעת המדדים הנ"ל יפעלו באופן מעט שונה על סוגי
קרקע/מצע שונים.
חשוב לזכור שמומלץ לנסות לקבוע את גיל העקבה (או נתיב העקבות) לאחר שהמשכנו קצת על הנתיב
 וראינו עוד עקבות וסימנים ולא רק על פי עקבה אחת.
 תודה לאסף בן דוד ועומרי שקוטאי על הערות חשובות וחוות דעת על המאמר`,
                btn: 'קיראו עוד',
                auther: 'עודד דוידוביץ',
            },

            {
                Id: 5,
                images: [
                    {
                        url: 'assets/images/traces/giul11.jpg',
                        description: `עקבות אדם בחוף הים ביום עם רוח חזקה מאוד. בחלקה התחתון של התמונה החול לח ורטוב והעקבות נראות בצורה ברורה. בחלקה העליון של התמונה החול יבש ולפיכך מתפזר יותר ברוח, שם העקבות נמחו כליל על ידי הרוח. `
                    },
                    {
                        url: 'assets/images/traces/giul12.jpg',
                        description: `
                        אבן שקועה באדמה, פני האבן בצבע בהיר.
                        `
                    },
                    {
                        url: 'assets/images/traces/giul13.jpg',
                        description: `אותה האבן לאחר תזוזה, חלקה התחתון שהיה בתוך האדמה כהה בהשוואה לחלקה העליון, ניתן לראות את ה"כיס" שנותר באדמה במקום מושבה של האבן לפני שהוזזה ממקומה`
                    },
                    {
                        url: 'assets/images/traces/giul14.jpg',
                        description: `משמאלה של האבן הגדולה שבמרכז התמונה ניתן לראות מרווח ברור בינה לבין פני הקרקע. מרווח זה מעיד על תזוזת האבן. לאחר זמן מה מרווח זה יתמלא שוב באבק וחול. חדי העין יבחינו באלכסון למעלה מהאבן בסימני מתאר של חלק מפרסת הצבי שדרך במקום`
                    },
                    {
                        url: 'assets/images/traces/giul15.jpg',
                        description: `  עקבת יחמור במהלך גששות מעקב באנגליה , ניתן לראות שבמקרה זה הפרסות הרימו חלק מהעלים ונוצרה מעיין מאורה קטנה`
                    },
                    {
                        url: 'assets/images/traces/giul16.jpg',
                        description: ` עקבת אייל פרדי לבן-זנב בוורמונט ארה"ב, באזור מכוסה עלים. ניתן לראות העברה של בוץ לעלה עליו דרך האייל, בנוסף ניתן לראות את צורת הפרסות על העלה ואת הצורה בה חציו העליון של העלה עומד בצורה לא טבעית.
                         `
                    },
                    {
                        url: 'assets/images/traces/giul17.jpg',
                        description: `רמיסה של עשב. כיוון התנועה הוא מתחתית התמונה לחלקה העליון של תמונה. ניתן לראות גם שינוי צבע ביחס לשאר העשבים, שינוי זה נוצר עקב הזווית השונה בה מוחזר האור עקב שינוי זווית העשבים ועקב חשיפה של צדדים שפחות חשופים לשמש. שינוי צבע נוסף אפשר למצוא במקרים בהם ירד הרבה טל על הצמחייה ומעבר החיה מסיר את הטל שהצטבר על הצמחייה`
                    },
                    {
                        url: 'assets/images/traces/giul18.jpg',
                        description: `מימין, עקבה שהוטבעה כשעה לאחר הגשם, עקבה שנראית "רטובה". ומשמאל 24 שעות לאחר מכן עקבה יבשה יחסית מכיוון שבמקרה זה לא ירד הרבה גשם ומתחת לשכבה הגלויה החול כבר הספיק להתייבש או אפילו לא נרטב מלכתחילה. מסביב לעקבות ניתן לראות את העקבות שהשאירו טיפות הגשם`
                    },
                ],
                date: 'מרץ 2020',
                type: '',
                title: 'דגשים לגששות מעקב וגיול בסוגי מצעים שונים',
                content: `
                דיונות חול: חשיבות יתרה למודעות למשטר הרוחות ועוצמתו. מספיק משב רוח אחד חזק של כמה
שניות והעקבה יכולה להימחק. לעיתים מתאר העקבה אינו ברור עקב קריסת חול פנימה.
אחד האתגרים הגדולים הינו השונות בצורת העקבות ומראה העקבות . כך לדוגמא באזור בו
העקבות פחות חשופות לרוח הן תהיינה יותר ברורות ותיראנה יותר טריות ובאותו השביל במהלך
גששות מעקב אחר אותה החיה במידה והעקבות נמצאות באזור שיותר חשוף לרוח אזי העקבות
תהיינה מטושטשות וכביכול "ישנות" יותר מהעקבות שפחות נחשפו לרוח. לעיתים חלק מהעקבות
יימחקו כליל.
מצבים אלו יכולים לבלבל את הגשש ולגרום לו להטיל ספק בכך שהוא עוקב אחר אותה החיה, על
הגשש להיות מודע לכך ולהיעזר בסבלנות וביטחון ולוודא שהוא על העקבות הנכונות בהמשך הדרך.

אבנים/חצץ: נחפש אבנים הפוכות שיצאו ממקומן, בד"כ תחתית האבנים שיצאו ממקומן תהיה כהה
יותר בגלל הלחות שבאדמה, הידבקות החול ואי חשיפה לשמש ורוח. כמו כן לעיתים נזהה את
המקום ממנו יצאה האבן (מעין "כיס" באדמה אליו האבן מתאימה בצורתה) וזה יכול לעזור בזיהוי
סימן שמישהו עבר במקום.
לעיתים באבנים שלא יצאו ממקומן נחפש דחיפה עמוקה שלהן אל תוך האדמה, כניסה עמוקה שכזו
יכולה להשאיר רווחים בין מיקום האבן עכשיו למיקומה המקורי לפני הדחיפה. במידת הצורך נגע
במספר אבנים בעדינות, באבנים שדרכו עליהן ולא זיהינו סימני הפיכה או דחיפה פנימה, נוכל לעיתים
במגע עדין לחוש שהן מתנדנדות ולא מקובעות חזק לקרקע.

אזורי עשבייה/צמחייה צפופה :רמיסה של עשב (באנגלית פלגינג)-במקרים מסוימים כאשר
דורכים על צמחים/עשבים אזי הם מתכופפים לכיוון התנועה של מי שדרך עליהם, לדוגמא: הלכתי
באזור עשבי לכיוון צפון אזי העשבים יהיו כפופים/נטויים לכיוון צפון. סוגי צמחים מסוימים פשוט יחזרו
במהירות לזווית עמידתם המקורית. לעיתים עשבים טריים וגמישים גם יחזרו למקומם כעבור זמן קצר
יחסית.
כמו כן צריך לקחת בחשבון שבעלי חיים יכולים לנוע בצורה שפחות תשטח עשבים בצורה רציפה
אלא רק במקומות נקודתיים בהם הרגל ממש נחתה מזווית אנכית ופחות בתנועה אופקית
של הליכה ולכן יהיה קשה יותר לקבוע את כיוון התנועה של בעל החיים.
.
לפעמים אפשר לאתר פציעות על עשבים אשר נלחצו על משטח קשה. פציעה טרייה נראית בד"כ
בצבע שחור/ירוק כהה וניכרת לחות/רטיבות באזור הפציעה. ככל שחולף הזמן אזור הפציעה (הגלד),
מתייבש והופך לבהיר יותר, משחור/ירוק כהה לחום כהה ואחר כך חום בהיר.
במקרים מסוימים יכול להיווצר לאחר זמן מה חור במקום הפציעה (רקמה שמתה והתייבשה ונשרה).
עלים: על פי רוב לא נראה עקבה ברורה, במקרה הטוב נראה מתאר של עקבה על העלים. על כן
נחפש שינויי צורה כגון עלים שלא מונחים באופן טבעי, שקעים ואזורים משוטחים במקום בו נטבעה
העקבה, "מאורות" אותן יצרו העקבות (בעיקר של פרסתנים כאשר הפרסה שלהם יכולה ליצור בעת
הדריכה מעין בור קטן כמו מערה קטנה שפיתחה מנוגד לכיוון התנועה) ,חלל בין העלים, קרעים,
סדקים, חשיפה של אדמה מתחת לשכבת העלים, שינויי צבע, העברה של חול/בוץ על העלים,
הטבעה של העקבה או חלקים מהעקבה על העלים .

בוץ : בקרקע בוצית לעיתים קשה יותר להעריך את גיל העקבה, העקבה יכולה להראות כעקבה
"חדשה" לאורך זמן רב.
במידה והעקבה מאוד טרייה אזי ייתכן שעדיין לא יחדרו מים לתוכה.
המהירות שבה יתמלאו מים בתוך העקבה הינה כתלות כמות הלחות/מים באדמה שמסביב לעקבה.
לפעמים יהיה קשה לזהות את סוג החיה כאשר העקבות נמצאות בבוץ עמוק, כמו כן גודל העקבה
יכול להראות שונה מאשר בחול יבש ולא עמוק.

חרסית: לעיתים "מחזיקה" טוב את העקבה וצורתה למשך זמן רב גם בתנאי מזג אוויר גשום ולכן
מוסיפה לאתגר התיארוך.
קרקע קשה: ישנם סוגי קרקעות שבתנאים מסוימים הופכים לקשים מאוד (כמו בהרבה מקומות
בד.אפריקה), לאחר שירד גשם והאדמה התייבשה, הקרקע הופכת לקשה מאוד ועם מעט אבק.
במצבים אלו קשה לפעמים לראות עקבות ברורות ולכן ננסה לזהות גם חלקי עקבות, סימני שפשוף
על האדמה, אבנים שזזו ממקומן ועשבייה משוטחת .

לכל קרקע/מצע ייתכנו מאפיינים ודגשים שונים מבין המאפיינים שנכתבו למעלה.*
*תודה לאסף בן דוד ועומרי שקוטאי על שביקרו את המאמר*

                `,
                btn: 'קיראו עוד',
                auther: 'עודד דוידוביץ',
            },
            {
                Id: 6,
                images: [
                    {
                        url: 'assets/images/traces/mahshavot.jpg',
                        description: ''
                    },
                ],
                date: 'מאי 2020',
                type: '',
                title: 'מחשבות על גששות כדרך חיים',
                content: `
                נראה שבימים אלה בעת מגפת הקורונה העולמית אנו נמצאים בתקופה מאוד מבלבלת ועם המון חוסר וודאות. משבר הקורונה לא פוסח על אף אחד ומוקדם לומר מה יהיו תוצאות המשבר ואיך ייראה העולם ביום שאחרי.
ייתכן שלמשבר זה יש את היכולת.פוטנציאל לגרום לנו כבני אדם לשנות תפיסות מחשבתיות והרגלים בעיתיים שעד היום פעלנו על פיהם בין אם במודע ובין אם לא , בין אם כי ככה כולם פועלים או פשוט כי נולדנו למצב קיים.
ניכר כי עלינו לשוב כחברה להסתמך על ערכי בסיס פשוטים. ערכים כגון: פשטות, הסתפקות במועט, קרבה לטבע, אחדות וערבות הדדית ועוד... לטעמי העיסוק בגששות יכול לקדם ערכים אלו.
מקורות הגששות שזורים בהתפתחותנו כבני אדם מראשיתה של האנושות.
כאשר חברות שונות עסקו בצייד וליקוט והיו קשובות יותר לטבע ולמעגלי החיים השונים. ניתן להניח  שהקשב והרגישות לטבע תרמו להבנה שהכל קשור בהכל ושישנה השפעה הדדית בין החיים והסביבה כחלק ממעגל החיים. גם בזמנים המודרניים כל אחד ואחד מאיתנו מגשש ביום יום על מנת להסתדר בסביבה. בין אם זה כאשר אנו נוסעים ברכב וקשובים לסימנים שונים כגון: שלטים, מכוניות , מזג אוויר על מנת להגיע למחוז חפצנו בשלום. ובין אם על ידי קריאת שפת הגוף של הסובבים אותנו על מנת להגיב באופן מותאם. בדיוק כמו בגששות אנו נעזרים ב"עקבות" וסימנים שונים על מנת שנוכל להתנהל בעולם בצורה טובה.
ישנן מספר גישות לאומנות הגששות וכאן ארצה לספר על הגישה שלי לאומנות עתיקת יומין זו.
ההשפעה המרכזית על איך שאני מבין את אומנות הגששות הינה הגישה האפריקאית שניתן לכנותה כגישה של "גששות מעשית" בפשטות אפשר לומר שבגששות מעשית המטרה הינה לגשש אחר בעל החיים במטרה להגיע אליו בלא להפריע לו. כפועל יוצא של מטרה זו השאיפה היא לגשש באופן יעיל וזורם.
גששות זו מבוססת על עובדות בשטח וניסיון עבר אך נותנת מקום רב גם לדמיון ולהשערת השערות שונות אשר חלקן יכולות להיות אפילו אינטואיטיביות ואשר על הגשש לאמתן או להפריכן בהמשך על פי העקבות וסימני השדה אותן הוא מאתר בשטח. כל זאת בהתאם לחוקי אתיקה ברורים על מנת שלא לפגוע בסביבה ובבעלי החיים בעת המעקב אחריהם.
אחד הדברים שאני הכי אוהב בגששות זה פשטותם של הדברים, אין צורך בציוד יקר ומתוחכם, ישנו חיבור בלתי אמצעי לטבע אותו אנו חווים בכל החושים. הגישוש מלמד אותנו דברים רבים על התנהגותם של בעלי החיים ועל כלל הסביבה. התובנות השונות שאנו יכולים ללמוד מן הטבע יכולות לתרום רבות לחיינו.
הטבע באופן טיבעי כולל מערכות של איזונים ובלמים כחלק ממעגל החיים. כך למשל בעל חיים טורף לא יצוד בד"כ יותר ממה שהוא או להקתו צרכים על מנת לשרוד, לפעמים בעלי חיים יטמינו אוכל לעתות משבר אך לא באופן כפייתי או חמדני. מה שיישאר מן הציד במידה ויישאר, יאכל על ידי בעלי חיים אחרים.
הגששות תורמת להבנה שכולנו משפיעים ומושפעים מהסובב אותנו. כך לדוגמא במקומות רבים בהן יש פעילות רבה של בני אדם כולל הפרעות שונות , ניכר שחלק מבעלי החיים עוברים להיות יותר פעילים בשעות בהן יש פחות פעילות של בני אדם. ישנן עוד הרבה דוגמאות אך הדבר המרכזי בעיני הינו שהחיבור הבלתי אמצעי לטבע, חיבור אשר הגששות יכולה לתרום לו רבות, יכול בתורו להפוך אותנו לבני אדם טובים ורגישים יותר לסובב אותנו ולחזק ערכים חשובים להתנהלותנו יחד על פני האדמה.

                `,
                btn: 'קיראו עוד',
                auther: 'עודד דוידוביץ',
            },
            {
                Id: 7,
                images: [
                    {
                        url: 'assets/images/traces/masoret.jpg',
                        description: ` `
                    },
                ],
                date: 'מאי 2020',
                type: '',
                title: 'גששות במסורת היהודית',
                content: `
                מספר מקורות שקשורים לגששות באופן ישיר או עקיף ,חלקם עם פרשנות אישית**
1.בתנ"ך מופיע השורש ג.ש.ש פעמיים בלבד בספר ישעיהו פרק נ"ט פסוק י'
"נגששה כעיוורים קיר וכאין עיניים נגששה כשלנו בצהריים כנשף באשמנים כמתים"

 "אֲשֶׁר חֵרְפוּ אוֹיְבֶיךָ יְהוָה אֲשֶׁר חֵרְפוּ עִקְּבוֹת מְשִׁיחֶךָ".
2.תהילים פרק פ"ט פסוק נ"ב:
בספר האגדה(של רבניצקי וביאליק) השואב ממקורות חז"ל שונים מתואר המשל הבא
3. בעמוד פ"ח/פ"ט פיסקה פד:
" פעם אחת היה דוד מלך ישראל יושב בגנו וראה צרעה אוכלת עכביש. אמר דוד לפני
הקדוש ברוך הוא: ריבונו של עולם מה הנאה באלו שבראת בעולמך? צרעה מפסדת דבש
ואין בה הנאה , עכביש אורג כל השנה ואין לבוש.
אמר הקדוש ברוך הוא :דוד, מלעיג אתה על בריותי -תבוא שעה ותצטרך להן.
וכשנחבא דוד במערה מפני שאול המלך, שלח הקדוש ברוך הוא עכביש וארג על פי המערה
וסגר אותה. בא שאול וראה פי המערה ארוג.  אמר: ודאי לא נכנס אדם לכאן, שאם נכנס
היה קורע את האריג לקרעים- והלך לו ולא נכנס לשם...

4.שמואל א' פרק ט' פסוק ג': "ותאבדנה האתונות לקיש אבי שאול ויאמר קיש אל שאול
בנו קח נא איתך את אחד מהנערים וקום לך בקש את האתונות". סביר בהחלט להניח
ששאול גישש אחר האתונות

5.אף משה לא בחנו הקב"ה אלא בצאן
שמות רבה פרשה ב' פיסקה ב': אָמְרוּ רַבּוֹתֵינוּ: כְּשֶׁהָיָה משֶׁה רַבֵּינוּ עָלָיו הַשָּׁלוֹם רוֹעֶה
צֹאנוֹ שֶׁל יִתְרוֹ בַּמִּדְבָּר, בָּרַח מִמֶּנּוּ גְּדִי וְרָץ אַחֲרָיו עַד שֶׁהִגִּיעַ לַחָסוּת. כֵּיוָן שֶׁהִגִּיעַ לַחָסוּת,
נִזְדַּמְּנָה לוֹ בְּרֵכָה שֶׁל מַיִם וְעָמַד הַגְּדִי לִשְׁתּוֹת. כֵּיוָן שֶׁהִגִּיעַ משֶׁה אֶצְלוֹ, אָמַר: אֲנִי לֹא
הָיִיתִי יוֹדֵעַ שֶׁרָץ הָיִיתָ מִפְּנֵי צָמָא, עָיֵף אַתָּה! הִרְכִּיבוֹ עַל כְּתֵפוֹ וְהָיָה מְהַלֵּךְ. אָמַר הַקָּדוֹשׁ
בָּרוּךְ הוּא: יֵשׁ לְךָ רַחֲמִים לִנְהֹג צֹאנוֹ שֶׁל בָּשָׂר וָדָם, כָּךְ, חַיֶּיךָ - אַתָּה תִרְעֶה צֹאנִי יִשְׂרָאֵל.
הָוֵי: "וּמשֶׁה הָיָה רוֹעֶה" .
בפשט נראה שמשה פשוט רדף אחרי הגדי, בדרש ייתכן שהוא עשה צייד בהתשה, כלומר
גישש אחריו עד שהגדי הגיע לאפיסת כוחות.

6.שופטים פרק ד' פס יז'- כב': "וסיסרא נס ברגליו אל אוהל יעל אשת חבר הקיני...והנה
ברק רודף את סיסרא ותצא יעל לקראתו...". האם ייתכן שברק גישש אחרי סיסרא?

7.ספר שופטים פרק ז' פסוק כג'-כד': "ויצעק איש ישראל מנפתלי ומן אשר ומן כל מנשה
וירדפו אחר מדיין. ומלאכים שלח גדעון בכל הר אפרים לאמר רדו לקראת מדין ולכדו להם
את המים עד בית ברה ואת הירדן..."
ניתן להניח שהמרדף היה באמצעות עקבות נראה שניתן לקבוע שנעשתה גששות השערתית
 (ספקולטיבית) לגבי "מעבר הכרחי" שבו יעברו המדיינים וכוחות אחרים עשו "חיתוך" על
מנת לתפסם

               `,
                btn: 'קיראו עוד',
                auther: 'עודד דוידוביץ',
            },
            {
                Id: 10,
                images: [
                    {
                        url: 'assets/images/traces/nafshi1.jpg',
                        description: ` סימני יציאה מלווים במים אשר נזלו מגופו של חזיר הבר.`
                    },
                    {
                        url: 'assets/images/traces/nafshi2.jpg',
                        description: ` סימני הכניסה אל תוך האגם `
                    },
                    {
                        url: 'assets/images/traces/nafshi3.jpg',
                        description: `מבט אל הגדה השנייה מאזור היציאה של חזיר הבר `
                    },
                ],
                date: 'מאי 2020',
                type: '',
                title: 'הצד הנפשי שבגששות מעקב',
                content: `
                כבכל דבר שאנו עושים בחיינו , הנפש והצד המנטלי משפיעים גם על יכולת הגישוש שלנו.
לחץ
ניכר שרמות מסוימות של לחץ מפחיתות מיכולת הגישוש שלנו ולכן חשוב להיות מודעים למשתנה
זה ולעבוד על יכולתנו להתמודד עם לחץ באופן טוב ובונה.
דוגמא שכיחה אשר ראיתי פעמים רבות בשטח היא כאשר מישהו מוביל גישוש ופתאום מאבד את
העקבות ואז החבר'ה שהולכים לידו ואינם הגששים המובילים מוצאים את העקבות בקלות רבה יותר
ממי שמגשש עכשיו.
נראה שההסבר המרכזי לכך הוא שיש עליהם פחות לחץ מאשר על הגשש ש"נושא" באחריות
המרכזית על הגישוש. בנוסף ישנם משתני לחץ נוספים של האזור עצמו והאתגרים אותו הוא מציב
כגון: שטח קשה לגישוש, חיות שעלולות להיות מסוכנות .
במבחני הערכה של הסייבר -טרקר המעריך נמצא מאחורייך וכל הזמן בוחן אותך וזה גם מוסיף
לחץ.
באחת ההערכות שהייתה לי, הפידבק שקיבלתי היה שאני חושב יותר מדי.
במקום פשוט לגשש נכנסתי למחשבת יתר, האם עכשיו אני צריך גששות השערתית? למה אני
רק בגששות שיטתית? איך הבוחן מתרשם ממני עד עכשיו? דווקא כאשר הייתי מפוקס על נתיב
העקבות ו"שכחתי" שמישהו מעריך אותי אז גיששתי טוב יותר.
צרפתי ציטוט מראיון בכתבה שנעשתה עם אום פוקי, גשש מאסטר מד. אפריקה.
"גששות זה לא רק לחפש עקבות על הקרקע, אתה צריך להיות חופשי, רגוע ומודע למה שקורה
סביבך להשתמש לא רק בעינייך אלא בכל החושים"
"אתה צריך להיות שמח ורגוע (משוחרר), זהו הסוד של הגששות"
גם מייק טייסון, אחד המתאגרפים הטובים והקשוחים אי פעם, אמר באחד מהראיונות שלו שלוחם
טוב הוא לוחם שמח. (לאו דווקא לוחם כועס)
בטחון עצמי
שם המשחק הוא מודעות ליכולותייך. מצד אחד חשוב שלא להיות עם בטחון עצמי מופרז אשר יכול
לגרום לטעויות אשר עלולות להוביל להתעלמות.חוסר תשומת לב לסימנים וסיטואציות משמעותיות
בגישוש ולחוסר פתיחות בקריאת מצבים שונים , שינויים והפתעות אפשריות ,התעקשות על חיפוש
במקום מסוים והתרחקות מהנתיב הנכון ועוד...

מצד שני בטחון עצמי נמוך עלול לגרום להיסוס ולפקפוק בקריאת מצבים.סימנים וסיטואציות שונות
ובכך לפספס אותם או לפרש אותם לא נכון ולגרום לבזבוז זמן וחוסר זרימה בגישוש.
גמישות מחשבתית וגמישות בגישוש
נשאף להיות פתוחים לאפשרויות שונות, בעלי החיים יכולים להפתיע אותנו בהתנהגותם ובבחירות
שלהן.
אם ניצמד יותר מדי למה שאנחנו חושבים שצריך להיות, במקום למה שקורה באמת אזי נפספס זמן
יקר.
גם במהלך חיפושנו אחר עקבות וסימנים נזכור שעקבות וסימנים שונים יכולים להראות בתנאים
 מסוימים שונים ממה שחשבנו שיראו.
לפני מספר שנים עקבתי אחר חזיר בר אשר עקבותיו הובילו לאגם קטן.שלולית חורף, הסתכלתי
סביב ולא ראיתי עוד עקבות באזור, התקדמתי מספר מטרים לאורך הגדה ימינה ושמאלה ולא זיהיתי
עקבות.
לא נותרה לי ברירה והקפתי את האגם לצד השני ושם למרבה תדהמתי גיליתי סימני עקבות של
יציאה מהאגם, מלווים במים שנזלו מגופו הרטוב של חזיר הבר. ואז גיליתי שחזירים יכולים לשחות.

אחד הדברים היפים בגששות זה שאם אנחנו פתוחים וסקרנים לאפשרויות שונות אז תמיד נוכל
לגלות דברים חדשים בשטח.
פחד
להיות מוכנים להעז ולא לפחד מלעשות טעויות. איפה אני פוגש את זה בשעה שאני מגשש?
בד"כ כאשר אני מגשש בגששות השערתית וצריך לשער באיזה נתיב החיה התקדמה ושם לחפש
עקבות. הפחד מלבחור בנתיב הלא נכון ולאבד את העקבות , הפחד מלעזוב את הגששות השיטתית
בה אני מחפש כל עקבה ועקבה וכביכול לא "מאבד" את נתיב העקבות אך מאבד לפעמים זמן יקר
ואת האפשרות לזרום בצורה טובה בגישוש ולהיכנס יותר לראש החיה

                `,
                btn: 'קיראו עוד',
                auther: 'עודד דוידוביץ',
            },
            {
                Id: 8,
                images: [
                    {
                        url: 'assets/images/traces/headsUp.jpg',
                        description: ` גששות בראש מורם`
                    },
                ],
                date: 'מאי 2020',
                type: '',
                title: 'גששות בראש מורם',
                content: `
                אחד ההבדלים בין גשש טוב ומנוסה לגשש מתחיל זה האם הגשש מגשש רוב הזמן בראש מורם או
בראש מורכן המחפש עקבות ליד כפות רגליו.
כאשר למדתי לגשש באפריקה לא הבנתי את משמעות הדבר ואחד ממורי ,גשש מדהים בשם ז'אק,
התעקש על העניין עד כדי כך שהציע לחבר לי קוץ לדש הבגד מתחת לסנטר על מנת שכל פעם
שאוריד את הראש הקוץ ידקור אותי...
הנטייה שלנו כגששים מתחילים וחסרי ביטחון הינה לחפש את העקבות הקרובות אלינו ולכן ראשנו
מורכן רוב הזמן.
באחד ממסעותיי לאפריקה גיששתי עם גילברט, גשש משבט ה-"שאנגאן" אשר למד לגשש כאשר
השגיח על עדר הבקר של משפחתו בילדותו. גילברט עקב אחרי באפאלו ואני ועוד שני תלמידים
התלווינו אליו על מנת ללמוד. הגענו לדרך עפר קשה ויבשה אשר במבט ראשון לא ראינו בה עקבות.
גילברט המשיך ללכת בנינוחות ונראה היה שהוא סתם מהלך לו בחיק הטבע ומביט אל עבר האופק,
בשלב מסוים אחת התלמידות פנתה אל גילברט וביקשה ממנו קצת במבוכה וקצת בחוסר אמון
להראות לה את העקבות של הבאפאלו על הדרך מכיוון שהיא (ובעצם כולנו) לא ראינו כלום.
 גילברט חזר אחורה מספר מטרים והתחיל להראות לנו, במקום אחד חלק קטן מפרסת הבאפאלו,
במקום אחר שפשוף קל על האדמה וכן הלאה...
גשש מנוסה מחפש רוב הזמן עקבות וסימנים במרחקים של 5-15 מטר ולפעמים אף יותר.
כאשר צברתי מעט יותר ניסיון וביטחון שמתי לב שאני אכן מזהה עקבות שנמצאות במרחק כמה
מטרים ממני ולכן אין כל סיבה להסתכל רוב הזמן לאזור כפות הרגליים שלי.

גששות מעקב בראש מורם וזיהוי עקבות וסימנים במרחק מזמנים לנו יתרונות רבים.
1.מאפשר לנו תנועה רציפה ומהירה יותר וצבירת מומנטום והמשכיות על נתיב העקבות ולא תנועה
של עצירה-המשך-עצירה-המשך .
אני מזהה את העקבות מרחוק, הולך אליהן, תוך כדי תנועה אני ממשיך לחפש עקבות נוספות
להמשך וכבר מתקדם אליהן וכן הלאה. במידת הצורך מוודא מקרוב שהעקבות אותן זיהיתי מרחוק
אלו אכן העקבות הנכונות.
2.נוכל להבחין בהתפצלויות שבילים או נתיבי תנועה אפשריים ממרחק ונוכל לקרוא את
השטח על ידי הסתכלות על התמונה הרחבה יותר ובכך לנסות לשער איזו דרך סבירה יותר למעבר
על ידי החיה אחריה אנו עוקבים ואז נוכל לצפות מראש שינויי תנועה, היכן סביר שנמצא את עקבות
בעל החיים אחריו אנו עוקבים ועוד...

3.לפעמים ניתן להבחין טוב יותר בין אזור שעבר הפרעה כלשהי על ידי בעל החיים (על ידי
עקבה או סימן אחר) לבין אזורים לא מופרעים .זאת מכיוון שיש בסיס רחב יותר להשוואה ולא אזור
מצומצם יחסית מתחת  לכפות הרגליים שלנו.
4.זיהוי בעלי חיים ממרחק וכמובן הבחנה בחיה אחריה אנו עוקבים מבלי להיתקל בה בהפתעה
ולהפריע לה או לסכן את עצמנו.
5. פעמים רבות המבט מכוון את המודעות הכללית, כך למשל ראש מורכן למטה עלול לפגוע
במודעות הכללית שלנו לכל הסובב אותנו.
6.צפיית סכנות שונות להמשך, בעלי חיים שונים, תוואי שטח בעייתי, צמחייה שיכולה לפגוע בנו.
7.כאשר ראשנו מורכן ישנו יותר לחץ על אברים פנימיים כגון: קנה הנשימה, כלי הדם בצוואר,
הסרעפת. ולכן בראש מורם אנחנו נושמים יותר טוב ומקבלים יותר חמצן למוח ולגוף ולכן אנו יותר
מרוכזים ומתעייפים פחות.
*כמובן שלעיתים נביט בראש מורכן על מנת לחפש עקבות שקרובות אלינו אם על מנת למצוא עקבות בשטח מאתגר ואם על מנת לוודא שהעקבות שראינו ממרחק הם באמת העקבות של החיה אחריה אנחנו עוקבים. אין בזה פסול וכולם עושים זאת. השאלה היא מתי ובאיזו תכיפות. התשובה על כך משתנה בהתאם ליכולתו וניסיונו של הגשש, תוואי השטח, החיה אחריה אנו עוקבים ועוד משתנים.*

                `,
                btn: 'קיראו עוד',
                auther: 'עודד דוידוביץ',
            },
            {
                Id: 9,
                images: [
                    { url: 'assets/images/traces/boar1.jpg', description: ' עקבות חזיר בר' },
                    { url: 'assets/images/traces/boar2.jpg', description: 'חזיר בר' }],

                date: '2019',
                type: ' עקבות חזיר בר בעת דהירה',
                title: ' סיפור גששות אחרי חזיר בר',
                content: `
                בהולכי לגשש באזור חולי למדי פגשתי בעקבות חזיר בר אשר נראו לי כעקבות טריות יחסית (מלילה קודם)התבוננתי בעקבות מבט ממושך ואז התחלתי לגשש. בתחילת הגישוש אני מעדיף להתחיל באופן איטי יחסית ובגששות סיסטמטית וכך אני לומד להכיר את החיה הספציפית אחריה אני עוקב ומתאפשר לי להיכנס לתוך הגששות בצורה הדרגתית אך רציפה . לאחר מספר דקות בהן צברתי ביטחון על הנתיב, השטח נהיה יותר פתוח ויכולתי לראות את עקבות החזיר למרחוק ופשוט ללכת ישירות אליהן תוך כדי שאני מרים את ראשי ומחפש עקבות בהמשך. התחלתי לצבור מומנטום ולהרגיש תחושת זרימה.
לאחר כמה מאות מטרים החזיר נכנס לתוך שטח עם עשבים וקוצים יבשים המגיעים לעיתים עד לגובה הברכיים ואף יותר. האטתי מעט על מנת לנסות להתרגל לקרקע השונה ולכך שהעקבות שהיו עד עכשיו ברורות יחסית עלולות להראות מעט אחרת עכשיו ואכן כך היה. נראה היה שהחזיר נע על שבילים קיימים , זיהיתי גללים אופייניים ,חלקם היו ישנים וחלקם טריים יחסית ונתנו לי חיזוק חיובי לכך שאני על השביל הנכון בהתאם להערכתי את גילאי העקבות והזמן בו עבר שם החזיר.
לפעמים לא זיהיתי שביל או עקבות כלשהן וחיפשתי עקבות בהמשך הכיוון הכללי בו החזיר נע עד עכשיו ובכיוון זה שיערתי שימשיך לנוע מכיוון שכבר במרחק 100 מ' ממני זיהיתי מקום סבוך מאוד אותו אני מכיר מסיורים קודמים בשטח ובו חשדתי שהחזיר מחפש מחסה, למעשה עברתי לגששות השערתית תוך כדי שאני מנסה מדי פעם לאמת את השערתי עם עקבות וסימנים אותם מצאתי אך לא באופן תכוף וברור כמו באזור נטול הצמחייה.
הגעתי שוב לשטח חולי ללא הרבה צמחייה וראיתי המון עקבות שונות, לאחר סריקה קצרה מצאתי את עקבותיו בתוך "ים" העקבות השונות. לשמחתי רוב העקבות היו ישנות יחסית ועקבות החזיר עברו עליהן ובכך הפכו למובחנות יותר עקב טריותן היחסית . שוב ראיתי נתיב עקבות ברור שהוביל לאחר עשרות מטרים לאזור סבוך מאוד בו זיהיתי מעין מחילה צמחית אליה נכנסו עקבות החזיר אחריו עקבתי. עצרתי בנקודה זו משיקולי בטיחות ואתיקה על מנת לא להפריע לחזיר הבר שככל הנראה העביר שם את מנוחת היום עד לשעות הערב והלילה בהם ייצא שוב לחפש אחר מזון.
לשעה קלה זכיתי להכרות אינטימית עם רגעים בחייו של חזיר הבר אחריו גיששתי.                                עבורי זו חוויה מאוד מרגשת ומספקת

                `,
                auther: 'עודד דוידוביץ',
                btn: 'קיראו עוד'
            },
            {
                Id: 11,
                images: [
                    { url: 'assets/images/traces/zefa.jpg', description: 'צפע ארץ ישראלי' },
                    { url: 'assets/images/traces/shinanit.jpg', description: 'שנונית חולות' }],

                date: '2020',
                type: '  עקבות צפע ארץ ישראלי',
                title: 'גששות סימנים וגששות מעקב',
                content: `ניתן לחלק את עולם הגששות לשני חלקים המרכיבים יחד שלם אחד: \n 1.גששות עקבות וסימנים - זיהוי של עקבות וסימני שדה שונים כגון: גללים , שערות , עצמות, סימני אכילה, היכולת לדעת איזה בעל חיים השאיר את העקבות / סימנים אותם אנו מזהים בשטח \n 2. גששות מעקב - היכולת לעקוב אחרי עקבות והסימנים השונים במטרה להגיע אל החיה ובשאיפה שלא תהיה מודעת לנוכחותינו ושלא נפריע לה. \n מטאפורה ידועה מתייחסת לזיהוי עקבות וסימנים כלמידת אותיות בשפה ולגששות מעקב כ"חיבור" האותיות לכדי מילים , משפטים ואפילו סיפורים שלמים. \n גשש טוב מסוגל להגיד של איזו חיה העקבה אותה הוא רואה, מתי החיה עברה במקום, באיזו מהירות היא נעהוכיצד היא נעה, למה היא נעה במקום זה ולאן היא הולכת. \n הגשש יכול לנתח מצבים והתנהגויות שונות על פי העקבות והסימנים שבמקום. \n בזמן בו אנו מגששים אנו זוכים להיכנס לזמן מה לעולמו הנסתר של בעל החיים אחריו אנו עוקבים, ולהכיר אורח חיים שרובינו לא נחשפים אליו ביום יום, החיה הופכת להיות מוחשית יותר, יצור חי וייחודי עם רצונות שונים ואופי . \n היכולת הזאת ליצור חיבור עם חיית בר פראית בטבע הינה חוויה מיוחדת ומרגשת מאוד.`,
                auther: 'עודד דוידוביץ',
                btn: 'קיראו עוד'
            },
        ]
    },
];

export const homePageData: BlogDataModel = {
    cImages: [],
    category: 'home',
    name: 'דף בית',
    data: [
        {
            Id: 1,
            images: [{ url: 'assets/images/traces/camel830.jpg', description: 'עקבות גמל' }, { url: 'assets/images/traces/camel830.jpg', description: 'עקבות גמל' }],
            date: 'אוקטובר 2019',
            type: ' ים המלח',
            title: 'עקבות גמל',
            content: ' להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן',
            btn: 'קיראו עוד',
            auther: 'עודד דוידוביץ',
        },
        {
            Id: 2,
            images: [{ url: 'assets/images/traces/cat830.jpg', description: 'עקבות חתול' }, { url: 'assets/images/traces/cat830.jpg', description: 'עקבות חתול' }],
            date: 'אוקטובר 2019',
            type: ' תל אביב',
            title: 'עקבות חתול בית',
            content: ' להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן',
            btn: 'קיראו עוד',
            auther: 'עודד דוידוביץ',
        },
        {
            Id: 3,
            images: [{ url: 'assets/images/traces/nimia830.jpg', description: 'עקבות נמיה' }, { url: 'assets/images/traces/nimia830.jpg', description: 'עקבות נמיה' }],
            date: 'אוקטובר 2019',
            type: ' פלמחים',
            title: 'עקבות נימיה',
            content: ' להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן',
            btn: 'קיראו עוד',
            auther: 'עודד דוידוביץ',
        },
        {
            Id: 4,
            images: [{ url: 'assets/images/traces/dorban830.jpg', description: 'עקבות דורבן' }, { url: 'assets/images/traces/dorban830.jpg', description: 'עקבות דורבן' }],
            date: 'אוקטובר 2019',
            type: 'אפולוניה',
            title: 'עקבות יעל מצוי',
            content: ' להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן להשלים תוכן',
            btn: 'קיראו עוד',
            auther: 'עודד דוידוביץ',
        }
    ]
};
